import { ChevronDown, ShieldCheck } from "lucide-react";
import { BUSINESS, HERO_BG } from "@/data/site";
import { BTN_PRIMARY, BTN_PLATINUM } from "./styles";

export const Hero = () => {
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img src={HERO_BG} alt="Luxury renovated home interior" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A1F3C]/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1F3C] via-[#0A1F3C]/60 to-transparent" />
      </div>

      <div className="relative z-10 px-6 md:px-12 lg:px-24 py-32 max-w-5xl">
        <div className="inline-block bg-white px-5 py-3 mb-8 shadow-lg" data-testid="hero-logo">
          <img
            src="/assets/logo.png"
            alt="Apex Home Renovation LLC logo"
            className="h-24 md:h-32 w-auto"
          />
        </div>
        <p className="font-accent-script text-3xl md:text-4xl text-[#D4AF37] mb-4" data-testid="hero-tagline">
          {BUSINESS.tagline}
        </p>
        <h1
          className="font-serif text-5xl md:text-7xl font-semibold tracking-tight text-white leading-[1.05] mb-6"
          data-testid="hero-headline"
        >
          APEX HOME
          <br />
          RENOVATION LLC
        </h1>
        <p className="text-blue-100/80 text-base md:text-lg max-w-xl leading-relaxed mb-4" data-testid="hero-subtext">
          Where Quality Craftsmanship Meets Your Vision. Residential renovations that add value,
          beauty and comfort to your home.
        </p>
        <div
          className="flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#D4AF37] mb-10"
          data-testid="hero-badges"
        >
          <ShieldCheck className="h-4 w-4" />
          <span>Veteran-Owned &nbsp;•&nbsp; Family-Oriented &nbsp;•&nbsp; Est. {BUSINESS.established}</span>
        </div>
        <div className="flex flex-wrap gap-4">
          <a href="#consultation" data-testid="hero-book-consultation-btn" className={BTN_PRIMARY}>
            Book a Consultation
          </a>
          <a href="#estimate" data-testid="hero-request-estimate-btn" className={BTN_PLATINUM}>
            Request an Estimate
          </a>
        </div>
      </div>

      <a
        href="#about"
        data-testid="hero-scroll-down"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#D4AF37] animate-bounce"
        aria-label="Scroll to about"
      >
        <ChevronDown className="h-8 w-8" />
      </a>
    </section>
  );
};
